export default __webpack_public_path__ + "static/media/powerplay-large-icon.1a337511.png";